/* qeslint-disable */
// q@ts-nocheck

export enum VolumeUnits {
    CUBIC_METERS = "CUBIC_METERS",
    CUBIC_CENTIMETERS = "CUBIC_CENTIMETERS",
    CUBIC_KILOMETERS = "CUBIC_KILOMETERS",
    CUBIC_FEET = "CUBIC_FEET",
    CUBIC_INCHES = "CUBIC_INCHES",
    CUBIC_YARDS = "CUBIC_YARDS",
    CUBIC_MILES = "CUBIC_MILES"
}
